

<app-shared [type]="'inventaire'" [status]="'Annulé'"></app-shared>
